import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { styleMap } from "lit/directives/style-map.js";
import { when } from "lit/directives/when.js";

import { getAssetPath } from "@/helpers/base-path";

import styles from "./atlas-phone-flag.scss";

import AtlasElement, { type AtlasElementProps } from "@/components/atlas-element";

import "@/components/display/atlas-icon/atlas-icon";

export type PhoneFlagProps = AtlasElementProps & {
    countryCode: string;
    name: string;
};

/**
 * @tag atlas-phone-flag
 */
@customElement("atlas-phone-flag")
export default class AtlasPhoneFlag extends AtlasElement {
    static styles = styles;

    @property({ type: String, attribute: null }) countryCode: string;

    @property({ type: String, attribute: null }) name: string;

    /** @internal */
    /** @internal */
    public render() {
        const flagClass = {
            "atlas-phone-flag": true,
            [`flag-${this.countryCode.toLowerCase()}`]: true
        };

        const flagStyle = {
            "background-image": `url(${getAssetPath("assets/images/flags.png")})`
        };

        return when(
            this.countryCode === "other",
            () => html` <atlas-icon name="globe" size="2x" alt="no country selected"></atlas-icon> `,
            () => html`
                <div class="${classMap(flagClass)}" style="${styleMap(flagStyle)}" alt="${this.name} Flag"></div>
            `
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-phone-flag": AtlasPhoneFlag;
    }
}
